import React from 'react';

/**
 * Top-level error boundary.
 * Prevents white-screen-of-death — shows a friendly error card instead.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('AutoRadKo crash:', error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    const message = this.state.error?.message || 'Erreur inattendue';
    return (
      <div
        className="min-h-screen flex items-center justify-center px-5 py-10"
        style={{ background: 'linear-gradient(160deg, #1E3A8A 0%, #2563EB 35%, #DC2626 100%)' }}
        data-testid="error-boundary"
      >
        <div className="bg-white rounded-3xl shadow-2xl p-6 w-full max-w-[420px] text-center">
          <div className="text-5xl mb-3">⚠️</div>
          <h1 className="text-xl font-bold text-slate-900 mb-2">Une erreur est survenue</h1>
          <p className="text-sm text-slate-600 mb-5">
            L'application a rencontré un problème.
            <br />Cliquez sur le bouton ci-dessous pour réessayer.
          </p>
          <p className="text-xs font-mono text-slate-400 bg-slate-50 rounded-lg p-3 mb-4 break-all">
            {message}
          </p>
          <div className="flex flex-col gap-2">
            <button
              onClick={() => { this.reset(); window.location.href = '/'; }}
              data-testid="error-back-home"
              className="w-full bg-blue-600 text-white font-semibold py-3 rounded-xl hover:bg-blue-700 transition active:scale-95"
            >
              Retour à l'accueil
            </button>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload"
              className="w-full border-2 border-slate-200 text-slate-700 font-semibold py-3 rounded-xl hover:bg-slate-50 transition"
            >
              Recharger la page
            </button>
          </div>
        </div>
      </div>
    );
  }
}
